<template>
    <div
        v-if="isShow" v-visually="showDomainOnly && {
            serverId: 20304,
            area: 'domain-tip',
            ext: {page: 'material'},
        }"
        class="guide-card"
        :class="{'compact': showDomainOnly}"
    >
        <div class="icon"></div>
        <div class="content">
            <div class="title" v-html="titleText"></div>
            <div
                v-if="subTitleText" class="sub-title"
                v-html="subTitleText"
            ></div>
        </div>
        <veui-button class="btn" @click="jumpMaterial">
            {{ btnText }}
        </veui-button>
    </div>
</template>

<script>
import {Button} from 'veui';
import {mapState} from 'vuex';

export default {
    name: 'authention-guide-card',

    components: {
        'veui-button': Button
    },

    props: {},

    computed: {
        ...mapState({
            userInfo: state => state?.lawStore?.userInfoNew,
            authenticationStatus: state => state?.lawStore?.authenticationStatus
        }),

        // 已认证但律师职务和职业理念未填写则展示
        noPositionOrPhilosophy() {
            return this.authenticationStatus === 7
                && this.userInfo?.first_approve === 1
                && (!this.userInfo?.lawyer_info?.register_philosophy || !this.userInfo?.lawyer_info?.lawyer_position);
        },

        // 已认证但无认证备案信息
        noFiling() {
            return this.authenticationStatus === 7 && this.userInfo?.lawyer_info?.filing_info_status === 2;
        },

        // 已认证但备案信息过期
        filingExpired() {
            return this.authenticationStatus === 7 && this.userInfo?.lawyer_info?.filing_info_status === 1;
        },

        // 已认证但擅长领域未选满
        missingDomainCount() {
            const info = this.userInfo?.lawyer_info || {};
            const max = +info.max_fields_num || 0;
            const selected = info.register_domain
                ? info.register_domain.split('$').filter(Boolean).length
                : 0;
            return max > 0 ? Math.max(0, max - selected) : 0;
        },
        noFullDomain() {
            return this.authenticationStatus === 7 && this.missingDomainCount > 0;
        },

        isShow() {
            const path = this.$route.path;
            if (path === '/material') {
                // 优先级：备案 > 擅长领域 > 补充细节，三选一
                return this.noFiling || this.filingExpired || this.noFullDomain || this.noPositionOrPhilosophy;
            }
            return this.noPositionOrPhilosophy;
        },

        // 当前命中的是擅长领域分支（备案优先级更高，需排除）
        showDomainOnly() {
            return this.$route.path === '/material'
                && !this.noFiling && !this.filingExpired && this.noFullDomain;
        },

        titleText() {
            if (this.showDomainOnly) {
                return `您还有<span class="blue">${this.missingDomainCount}个</span>擅长领域未选，补全可获更多流量`;
            }
            const path = this.$route.path;
            if (path === '/material') {
                if (this.noFiling) {
                    return '完成备案，保障您的执业权益';
                }
                else if (this.filingExpired) {
                    return '更新备案，保障您的执业权益';
                }
                else if (this.noPositionOrPhilosophy) {
                    return '您有<span class="blue">几项</span>认证信息待补充';
                }
            }
            else {
                if (this.noPositionOrPhilosophy) {
                    return '您有<span class="blue">几项</span>认证信息待补充';

                }
            }
        },

        subTitleText() {
            if (this.showDomainOnly) {
                return '';
            }
            const path = this.$route.path;
            if (path === '/material') {
                if (this.noFiling) {
                    return `
                    <p>为确保您在平台的执业信息合规有效，请尽快上传您的执业认证备案材料</p>
                    <p>如果您已提供最新执业信息，请忽略本次提醒</p>
                `;
                }
                else if (this.filingExpired) {
                    return '您的执业认证备案信息已过期，为保持执业状态合格，请您立即更新执业认证备案材料';
                }
                else if (this.noPositionOrPhilosophy) {
                    return '完整资料获取更多优质安源！';
                }
            }
            else {
                if (this.noPositionOrPhilosophy) {
                    return '完整资料获取更多优质安源！';
                }
            }


        },

        btnText() {
            if (this.showDomainOnly) {
                return '立即完善';
            }
            const path = this.$route.path;
            if (path === '/material') {
                if (this.noFiling || this.filingExpired) {
                    return '立即上传';
                }
                else if (this.noPositionOrPhilosophy) {
                    return '立即完善';
                }

            }
            else {
                if (this.noPositionOrPhilosophy) {
                    return '立即完善';
                }
            }
        }
    },

    methods: {
        // 跳转我的认证
        jumpMaterial() {
            let editAnchor = 'personal-info';
            if (this.noFiling || this.filingExpired) {
                editAnchor = 'practice-info';
            }
            else if (this.showDomainOnly) {
                editAnchor = 'register_domain';
                this.$wywLog.send({
                    serverId: 20304,
                    area: 'domain-tip',
                    action: 'click',
                    page: 'material'
                });
            }
            if (this.$route.name === 'material') {
                this.$emit('clickEdit', editAnchor);
                return;
            }
            this.$router.push({
                name: 'material',
                query: {
                    isEdit: 'edit',
                    editAnchor: editAnchor
                }
            });
        }
    }
};
</script>

<style lang='less' scoped>
.guide-card {
    display: flex;
    height: 100px;
    align-items: center;
    border-radius: 8px;
    padding-right: 24px;
    margin-top: 24px;
    position: relative;
    border: 1.5px solid #fff;
    background: linear-gradient(270.14deg, #fff 62.84%, #e7f9ff 99.88%);

    &.compact {
        height: 70px;

        .icon {
            width: 42px;
            height: 42px;
            margin-top: 0;
            margin-left: 24px;
        }

        .content {
            margin-left: 15px;

            .title {
                font-size: 18px;
                font-weight: 500;
                line-height: 20px;
            }
        }

        .btn {
            position: absolute;
            right: 24px;
            margin-left: 0;
        }
    }

    .icon {
        flex-shrink: 0;
        width: 110px;
        height: 86px;
        margin-top: 14px;
        margin-left: 17px;
        background: url("https://lvlin-fe-saas.bj.bcebos.com/guideCard/icon.png") no-repeat center center;
        background-size: cover;
    }

    .content {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .title {
            color: #1e1f24;
            font-family: PingFang SC;
            font-weight: 600;
            font-size: 18px;
            line-height: 18px;

            /deep/ .blue {
                color: #05f;
            }
        }

        .sub-title {
            width: 814px;
            color: #848691;
            margin-top: 12px;
            font-size: 16px;
            line-height: 1;
            font-weight: 500;

            /deep/ p:not(:first-child) {
                margin-top: 12px;
            }
        }
    }

    .btn {
        margin-left: auto;
        width: 112px;
        height: 40px;
        border-radius: 6px;
        background: #0055ff1a;
        color: #05f;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 16px;
        line-height: 16px;
    }
}
</style>
